// removed by extract-text-webpack-plugin
module.exports = {"console":"console--22eyt","title":"title--3LZl8","sup":"sup--3GAN7","screenContainer":"screenContainer--GFoVt","strictContainer":"strictContainer--QcPl4","resetContainer":"resetContainer--Gq2QE","screen":"screen--27rYG","strictButton":"strictButton--1SXNw","resetButton":"resetButton--1yv7L","strictButtonOn":"strictButtonOn--4cOhE strictButton--1SXNw","label":"label--2zNMC"};


//////////////////
// WEBPACK FOOTER
// ./src/Console/Console.css
// module id = BdOF
// module chunks = 1